import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ListItem } from 'material-ui/List';
import SocialPerson from 'material-ui/svg-icons/social/person';
import { ROLES } from '@config/authentication';
import { ListItemInput, Button } from '@atoms';
import messages from './messages';

const ActionButtonContainer = styled.div`
  > * {
    margin-right: 4px;

    :last-child {
      margin-right: 0;
    }
  }
`;

const ListItemText = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default class UserListItem extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    isDeletingUser: PropTypes.bool,
    toggleEditUser: PropTypes.func.isRequired,
    deleteUser: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isDeletingUser: false,
  };

  get isAttendee() {
    return this.props.role === ROLES.ATTENDEE;
  }

  toggleEditUser = () => this.props.toggleEditUser(this.props.id);

  deleteUser = () => this.props.deleteUser(this.props.id);

  renderActionButtons = () => (
    <ActionButtonContainer>
      <Button small onClick={this.toggleEditUser}>
        <FormattedMessage {...messages.inputEditUser} />
      </Button>
      <Button small onClick={this.deleteUser} loading={this.props.isDeletingUser}>
        <FormattedMessage {...messages.inputDelete} />
      </Button>
    </ActionButtonContainer>
  );

  renderNestedItems = () =>
    this.isAttendee
      ? undefined
      : [
          <ListItemInput key="action-buttons">
            {this.renderActionButtons()}
          </ListItemInput>,
        ];

  render() {
    return (
      <ListItem
        leftIcon={<SocialPerson />}
        primaryText={<ListItemText>{this.props.email}</ListItemText>}
        primaryTogglesNestedList
        nestedItems={this.renderNestedItems()}
        nestedListStyle={{
          marginLeft: '18px',
          marginRight: '4px',
          textAlign: 'center',
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/molecules/UserListItem/UserListItem.component.js